import React from "react";

function StoryShare() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.138"
      height="20.146"
      viewBox="0 0 19.138 20.146"
    >
      <path
        id="Share_Icon"
        data-name="Share Icon"
        d="M13.2,17.132,8.972,14.825a4.029,4.029,0,1,1,0-5.5L13.2,7.013a4.032,4.032,0,1,1,.965,1.768L9.937,11.088a4.061,4.061,0,0,1,0,1.969l4.23,2.307a4.014,4.014,0,1,1-.966,1.768ZM6.029,14.087a2.015,2.015,0,1,0-2.015-2.015A2.015,2.015,0,0,0,6.029,14.087Zm11.08-6.044a2.015,2.015,0,1,0-2.015-2.015A2.015,2.015,0,0,0,17.109,8.044Zm0,12.087a2.015,2.015,0,1,0-2.015-2.015A2.015,2.015,0,0,0,17.109,20.131Z"
        transform="translate(-2 -2)"
        fill="#fff"
      />
    </svg>
  );
}

export default StoryShare;
